// The root route on a public host: `GET /api/events/resolve` maps the host name
// to an event (`settings.hosts`), so a badge QR to the bare host opens that
// event's Event view. It asks on every host, localhost included: the API answers
// 404 there and the landing page shows.
import { ApiError } from '@/api/client'
import { getResolve } from '@/api/event'

/** The slug this host serves, or null (no match, or the API unreachable). */
export async function resolveRoot(fetch: () => Promise<{ slug: string }> = getResolve): Promise<string | null> {
  try {
    const r = await fetch()
    return r && typeof r.slug === 'string' && r.slug ? r.slug : null
  } catch (e) {
    if (!(e instanceof ApiError)) console.warn('resolve failed', e)
    return null
  }
}

/** The route to replace `/` with, keeping the query (a `?token=` link, `?mock=1`) and hash. */
export function rootTarget(slug: string, query: Record<string, unknown> = {}, hash = '') {
  return { path: `/e/${encodeURIComponent(slug)}`, query: query as Record<string, string>, hash, replace: true }
}
